/** biome-ignore-all lint/a11y/useFocusableInteractive: avoid-breaking */
/** biome-ignore-all lint/a11y/noNoninteractiveElementToInteractiveRole: avoid-breaking */
/** biome-ignore-all lint/a11y/useKeyWithMouseEvents: avoid-breaking */

import React, { type FC } from 'react';

import { Typography } from '../../Typography/Typography';
import { LANG_OPTIONS } from '../Constants/Header.constants';
import { getFlagIcon } from '../Utils/HeaderItemHelpers';
import type { LanguageListProps } from './LanguageList.types';

import styles from '../Styles/LanguageList.module.css';

const LanguageList: FC<LanguageListProps> = React.forwardRef<HTMLDivElement, LanguageListProps>(
  (
    {
      dataTestId,
      heading,
      itemOnClick,
      onFocusEvents,
      onHoverEvents,
      options = LANG_OPTIONS,
      trackingFn,
    },
    ref,
  ) => {
    return (
      <div
        className={styles.languageList}
        data-test-id={dataTestId}
        onMouseOut={() => onHoverEvents(false)}
        onMouseOver={() => onHoverEvents(true)}
        ref={ref}
        role="menu"
      >
        <Typography variant="subheading1">{heading}</Typography>
        <ul>
          {options.map(langItem => {
            const Icon = getFlagIcon(langItem.langCode);

            return (
              <li key={langItem.langCode} role="menuitem">
                <a
                  aria-label={`${langItem.label} language select`}
                  href={langItem.href}
                  onBlur={() => onFocusEvents(false)}
                  onClick={() =>
                    itemOnClick(
                      {
                        fn: trackingFn,
                        obj: {
                          label: `${langItem.label} language select`,
                          href: langItem.href,
                        },
                      },
                      langItem.onClick,
                    )
                  }
                  onFocus={() => onFocusEvents(true)}
                >
                  {Icon}
                  <Typography variant="button3">{langItem.label}</Typography>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  },
);

export default LanguageList;
